var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _path, _path2, _line17, _line18, _path3, _line19, _line20, _line21, _path4, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoypack = function SvgDoypack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200.0mm",
    height: "300.0mm",
    viewBox: "0.0 0.0 200.0 300.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 200,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 200,
    y1: 0,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 100,
    y2: 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 200,
    y1: 100,
    y2: 200,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 200,
    y2: 200,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 200,
    y2: 100,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 200,
    y1: 200,
    y2: 300,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 300,
    y2: 300,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 300,
    y2: 200,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 197,
    y1: 11,
    y2: 11,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 30,
    y2: 30,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 200,
    y1: 35,
    y2: 35,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 40,
    y2: 40,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 2,
    y1: 50,
    y2: 50.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 198,
    y1: 50,
    y2: 50.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 2 50.5 c 49.5 60 147 60 196 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 2 150.5 c 49.5 60 147 60 196 0"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 2,
    y1: 150,
    y2: 150.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 198,
    y1: 150,
    y2: 150.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 2 149.5 c 49.5 -60 147 -60 196 0"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 2,
    y1: 150,
    y2: 149.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 198,
    y1: 150,
    y2: 149.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 2,
    y1: 250,
    y2: 249.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 2 249.5 c 49.5 -60 147 -60 196 0"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 198,
    y1: 250,
    y2: 249.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 197,
    y1: 289,
    y2: 289,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 270,
    y2: 270,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    x2: 0,
    y1: 260,
    y2: 260,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 2.5,
    y1: 11,
    y2: 12.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 0,
    y1: 12.5,
    y2: 12.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 2.5,
    y1: 11,
    y2: 9.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 0,
    y1: 9.5,
    y2: 9.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197.5,
    y1: 11,
    y2: 12.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 197.5,
    x2: 200,
    y1: 12.5,
    y2: 12.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197.5,
    y1: 11,
    y2: 9.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 197.5,
    x2: 200,
    y1: 9.5,
    y2: 9.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 2.5,
    y1: 289,
    y2: 290.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 0,
    y1: 290.5,
    y2: 290.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 3,
    x2: 2.5,
    y1: 289,
    y2: 287.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    x2: 0,
    y1: 287.5,
    y2: 287.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197.5,
    y1: 289,
    y2: 290.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 197.5,
    x2: 200,
    y1: 290.5,
    y2: 290.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 197,
    x2: 197.5,
    y1: 289,
    y2: 287.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 197.5,
    x2: 200,
    y1: 287.5,
    y2: 287.5,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 3.4,
    x2: 3.4,
    y1: 0,
    y2: 300,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 196.6,
    x2: 196.6,
    y1: 0,
    y2: 300,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 200,
    y1: 265,
    y2: 265,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoypack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doypack.cea01095.svg";
export { ForwardRef as ReactComponent };